import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $signUpFormTranslations = combine(i18n.$t, ({ t }) => ({
  title: t('sign_up'),
  email: {
    label: t('email'),
    placeholder: t('email_placeholder'),
    errors: {
      required: t('email_invalid_error'),
      email: t('email_invalid_error'),
      invalid: t('email_invalid_error'),
    },
  },
  username: {
    label: t('username'),
    placeholder: t('username_placeholder'),
    errors: {
      required: t('username_required_error'),
      username: t('symbols_error'),
      maxLength: t('username_max_length_error'),
      unique: t('username_unique_error'),
      invalid: t('username_invalid_error'),
    },
  },
  confirm: {
    label: t('confirm_password'),
    placeholder: t('confirm_password_placeholder'),
    errors: {
      required: t('confirm_password_required_error'),
      equalTo: t('confirm_password_match_error'),
    },
  },
  phoneNumber: {
    label: t('phone_number'),
    errors: {
      minLength: t('enter_phone_number'),
    },
  },
  submitButton: t('sign_up'),
  redirectQuestion: t('account_do_you_have'),
  redirectLink: t('sign_in'),
}))
